import React from "react";
import { useTranslation } from "react-i18next";
import { SearchEmptyIllustration } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";

interface EmptyStateProps {
  onClearSearch?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onClearSearch }) => {
  const { t } = useTranslation();

  return (
    <div
      className="h-full flex flex-row items-center justify-center px-10"
      data-test="global-search-empty-state"
    >
      <div className="w-[60%] flex justify-end">
        <SearchEmptyIllustration />
      </div>

      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-6">
          <Text variant="lgLabel">
            {t("globalSearch.emptyState.noResultsFound")}
          </Text>
          <Text variant="bodySecondary">
            {t("globalSearch.emptyState.tryDifferentKeywords")}
          </Text>
        </div>
        {onClearSearch && (
          <Button
            onClick={onClearSearch}
            variant="secondary"
            className="w-fit"
            data-test="global-search-empty-clear-button"
          >
            {t("globalSearch.emptyState.clearSearch")}
          </Button>
        )}
      </div>
    </div>
  );
};
